import { useMemo } from "react";
import { LoaderFunctionArgs, RouteObject, useMatches } from "react-router";
import { Page } from "src/dtos/Tmd.dtos";

type RouteData = { 
    helpPage: Page | null;
}

type RouteDataReturnValue<TData extends RouteData = RouteData> = Promise<TData> | TData;

export type LoaderFunction<Context = any, TData extends RouteData = RouteData> = {
    (args: LoaderFunctionArgs<Context>, handlerCtx?: unknown): RouteDataReturnValue<TData>;
} & {
    hydrate?: boolean;
};

export type AppRouteObject = Omit<RouteObject, 'loader' | 'children'> & {
    children?: AppRouteObject[];
    loader: LoaderFunction;
};

const useChildRouteData = <TData extends RouteData = RouteData>() => {
    const matches = useMatches();

    const data = useMemo(() => {
        if (!matches || matches.length === 0) {
            return undefined;
        }

        return matches[matches.length - 1].data;
    }, [matches])

    return data as (TData | undefined);
}

export default useChildRouteData